
























import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';

export default Vue.component('upload-control', {
  name: 'UploadControl',
  props: {
    'id': { required: true },
    'upload-to-file-path': { required: true },
    'override-file-name': { required: false },
    'override-mime-type': { required: false },
    'use-unique-folder': { default: true },
    disabled: {
      default: false
    },
    accept: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isUploadingFile: false,
      fileUploadErrorMessage: '',
      percentUploadComplete: 0
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  methods: {
    filesChange (fileList: any) {
      this.fileUploadErrorMessage = '';

      // 1MB = 1,048,576 bytes
      // Example: Restrict files over 5 MB (1,048,576 * 5)
      let sizeMBLimit = 12;
      if (fileList[0].size > (1048576 * sizeMBLimit)) {
        // Insert error handling for too large of a file.
        this.fileUploadErrorMessage = "Please upload a file smaller than " + sizeMBLimit + " MB.";
        return;
      }

      this.uploadFile(fileList[0]);
    },
    uploadFile (fileToUploadParam: any) {

      let self: any = this;
      let fileToUpload = fileToUploadParam;
      if(self.overrideFileName){
        fileToUpload = self.renameFile(fileToUploadParam,self.overrideFileName, self.overrideMimeType);
      }
      self.isUploadingFile = true;
      let uniqueFolder = self.useUniqueFolder? new Date().getTime() + '_' + Math.floor(Math.random() * 10000) + '/':'';
      let s3FilePath = self.uploadToFilePath + uniqueFolder + fileToUpload.name;
      const fileType = self.overrideMimeType || fileToUpload.type || 'text/plain';
      HTTP.get('api/s3/signed-url/put?contentType=' + fileType + '&s3key=' + s3FilePath )
      .then(function (response) {
        // self.isUploadingFile = false;
        if (!response.data || !response.data.data ) {
          throw new Error("Error retrieving presigned url.");
        }

        let preSignedUrl = response.data.data;
        const config = {
          headers: { 'Content-Type': fileToUpload.type },
          onUploadProgress: function (progressEvent: any) {
            let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            self.percentUploadComplete = percentCompleted;
          }
        }

        // Now that we have the url to upload to, lets do it!
        HTTP.put(preSignedUrl, fileToUpload, config)
        .then(function (response) {
          self.isUploadingFile = false;
          self.percentUploadComplete = 0;
          self.$emit("fileUploaded", s3FilePath, self.id, fileToUpload.name );
        })
        .catch(function (err) {
          console.log('response Error!');
          console.log(err);
          self.isUploadingFile = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred uploading file.'
          });
        })

      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        self.isUploadingFile = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred uploading file.'
        });
      })

    },
    renameFile(originalFile:File, newName: string, mimeType: string | undefined) {
      return new File([originalFile], newName, {
        type: mimeType || originalFile.type,
        lastModified: originalFile.lastModified,
      });
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/UploadControl.vue